<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
				<template #search>
                    <!-- 平台账户集资金汇总 -->
                    <div class="stats-bar flex">
                        <div v-for="(item, index) in balanceList" :key="index" class="stats-card" :class="'card-' + cardColors[index % cardColors.length]">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">{{item.accountSetName}}</span>
                                    <span class="stats-value">￥{{formatMoney(item.accountInfo && item.accountInfo.allAmount)}}</span>
                                </div>
                                <div class="stats-summary-row flex-start-center">
                                    <span><label>冻结金额：</label>￥{{formatMoney(item.accountInfo && item.accountInfo.freezeAmount)}}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                    </div>

					<m-search ref="search" :default-data="defaultSearchData" @clear="resetAccountSet">
						<m-search-item label="变更时间" colspan="2">
							<c-datetime
								:range="dateRangeLimit"
								start-name="start_date"
								end-name="end_date"
								:clear="false"
								:editable="false"
								:min-date="minDate"
								:max-date="maxDate"
							></c-datetime>
						</m-search-item>
						<m-search-item label="账户集">
							<!--账户集必选（不可清空），默认选中标准余额账户集-->
							<c-select name="accountSetNo" async :value-data="accountSetSelected" :search="{empty: true}" :clear="false" @search="searchAccountSetOptions"></c-select>
						</m-search-item>
						<m-search-item label="业务订单号">
							<c-input name="bizOrderNo" placeholder="请输入业务订单号"></c-input>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_platform_allinpay_flow_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
					</c-button>
				</template>

				<!-- 变更时间 -->
				<template #changeTime="{data}">
					{{data.changeTime || '-'}}
				</template>

				<!-- 变更前金额 -->
				<template #oriAmount="{data}">
					￥{{formatMoney(data.oriAmount)}}
				</template>

				<!-- 变动金额（正数增加，负数扣减） -->
				<template #chgAmount="{data}">
					<span :style="{color: getAmountColor(data.chgAmount)}">{{formatSignedMoney(data.chgAmount)}}</span>
				</template>

				<!-- 当前冻结金额 -->
				<template #curFreezenAmount="{data}">
					￥{{formatMoney(data.curFreezenAmount)}}
				</template>

				<!-- 当前账户余额 -->
				<template #curAmount="{data}">
					￥{{formatMoney(data.curAmount)}}
				</template>

				<!-- 备注 -->
				<template #remark="{data}">
					{{data.remark || '-'}}
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'

//账户集选项（通商云固定账户集：100001标准余额、100002标准保证金）
const ACCOUNT_SET_BALANCE = {name: '标准余额账户集', value: '100001'};
const ACCOUNT_SET_DEPOSIT = {name: '标准保证金账户集', value: '100002'};
const MIDDLE_ACCOUNT_B = {name: '标准中间代付账户集', value: '100005'};

export default {
	name: 'p_platform_allinpay_flow',

	data() {
		//变更时间格式化（yyyy-MM-dd）
		const pad = num => (num < 10 ? '0' + num : '' + num);
		const formatDate = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
		const now = new Date();
		const defaultStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);   //默认开始时间：7天前
		const minStartDate = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());      //最早可选：6个月前

		return {
			workType: 125,
			//变更时间单次查询区间限制（通联接口要求：含起始、结束不能超过31天）
			dateRangeLimit: {limit: 31},
			balanceList: [],        //平台账户集余额汇总（仅标准余额、标准保证金2个账户集）
			accountSetOptions: [ACCOUNT_SET_BALANCE, ACCOUNT_SET_DEPOSIT,MIDDLE_ACCOUNT_B],  //账户集搜索选项
			accountSetSelected: [ACCOUNT_SET_BALANCE],  //账户集选中项（默认：标准余额账户集）
			cardColors: ['blue', 'orange', 'green', 'purple', 'red', 'cyan'],
			//变更时间默认值（必填：默认30天前 ~ 今日，可修改不可清空）
			defaultSearchData: {
				start_date: `${formatDate(defaultStartDate)} 00:00:00`,
				end_date: `${formatDate(now)} 23:59:59`,
				//账户集必选，默认选中标准余额账户集
				accountSetNo: ACCOUNT_SET_BALANCE.value
			},
			//变更时间可选范围（最多支持查询近6个月数据）
			minDate: `${formatDate(minStartDate)} 00:00:00`,
			maxDate: `${formatDate(now)} 23:59:59`
		}
	},

	computed: {
		...mapState(['saasInfo'])
	},

	mounted() {
		this.loadBalance();
	},

	methods: {
		/**
		 * 加载平台账户集余额汇总（顶部资金汇总卡片，仅标准余额、标准保证金2个账户集）
		 */
		loadBalance() {
			this.request({
				url: '/financial/platform/allinpay/flow/balance',
				data: {},
				success: data => {
					this.balanceList = data || [];
				}
			});
		},

		/**
		 * 账户集下拉选项搜索回调（async 模式，选项固定为标准余额、标准保证金2个账户集）
		 */
		searchAccountSetOptions(keyword, resolve) {
			const options = this.accountSetOptions;
			resolve(keyword ? options.filter(item => item.name.indexOf(keyword) > -1) : options);
		},

		/**
		 * 重置搜索条件后恢复账户集默认选中：标准余额账户集
		 */
		resetAccountSet() {
			this.accountSetSelected = [ACCOUNT_SET_BALANCE];
		},

		/**
		 * 金额格式化（通联金额单位为分，转换为元展示，保留两位小数）
		 */
		formatMoney(val) {
			if (val === undefined || val === null || val === '') {
				return '0.00';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0.00' : (num / 100).toFixed(2);
		},

		/**
		 * 金额格式化（带正负号）
		 */
		formatSignedMoney(val) {
			if (val === undefined || val === null || val === '') {
				return '0.00';
			}
			const num = parseFloat(val);
			if (isNaN(num)) {
				return '0.00';
			}
			const amount = (num / 100).toFixed(2);
			return num > 0 ? `+${amount}` : amount;
		},

		/**
		 * 获取变动金额颜色（正数绿色，负数红色）
		 */
		getAmountColor(val) {
			if (val === undefined || val === null || val === '') {
				return '#333';
			}
			const num = parseFloat(val);
			if (isNaN(num) || num === 0) {
				return '#333';
			}
			return num > 0 ? '#16a34a' : '#dc2626';
		}
	}
}
</script>

<style lang="stylus" scoped>
	.stats-bar {
		flex-wrap: wrap;
		gap: 10px;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;

		.stats-card {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1 1 260px;
			min-height: 56px;
			padding: 8px 16px;
			border-radius: 6px;
			color: #fff;
			box-sizing: border-box;
			overflow: hidden;

			&.card-blue {
				background: linear-gradient(90deg, #2563eb, #3b82f6);
			}

			&.card-orange {
				background: linear-gradient(90deg, #f97316, #fb923c);
			}

			&.card-green {
				background: linear-gradient(90deg, #16a34a, #22c55e);
			}

			&.card-purple {
				background: linear-gradient(90deg, #7c3aed, #8b5cf6);
			}

			&.card-red {
				background: linear-gradient(90deg, #dc2626, #ef4444);
			}

			&.card-cyan {
				background: linear-gradient(90deg, #0891b2, #06b6d4);
			}

			.stats-info {
				position: relative;
				z-index: 1;

				.stats-title-row {
					display: flex;
					align-items: baseline;
					line-height: 24px;

					.stats-label {
						font-size: 12px;
						opacity: 0.95;
					}

					.stats-value {
						margin-left: 6px;
						font-size: 18px;
						font-weight: bold;
					}
				}

				.stats-summary-row {
					gap: .5em;
					margin-top: 2px;
					font-size: 11px;

					label {
						opacity: 0.9;
					}
				}
			}

			.stats-icon {
				position: absolute;
				right: 14px;
				top: 50%;
				transform: translateY(-50%);
				font-size: 32px;
				line-height: 1;
				opacity: 0.15;
			}
		}
	}
</style>
